import React, { useEffect, useState } from "react";
import '../../../../assets/css/valuelist.css';
import MainWrapper from "../../../MainWrapper";
import { Link, Navigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back, ic_mode_edit } from 'react-icons-kit/md';
import { Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import Create from "./models/CreateProductInfo";
import ConfirmDelete from "./models/ConfirmDelete";
import Edit from "./models/EditProductInfo";
import {
  PRODUCT_INFO_REQUEST,
  PRODUCT_INFO_CREATE,
  PRODUCT_INFO_DELETE,
  PRODUCT_INFO_EDIT,
  PRODUCT_INFO_STATE_CHANGE,
  MANUFACTURER_REQUEST,
  PRODUCT_TYPE_REQUEST,
} from "../../../../_utils/constants/ProductCatalog";
import {
  VENDOR_REQUEST
} from "../../../../_utils/constants/ValueList";
import Loader from "../../../layouts/Loader";
import { ToastContainer, toast } from 'react-toastify';

const ProductInfo = ({
  auth: { auth, isAuthenticated },
  ProductInfo: { valueList, isCreated, isDeleted, isEdited, isLoading },
  Manufacturer,
  vendor,
  ProductType,
  fetchProductInfo,
  submitProductInfoCreate,
  submitProductInfoDelete,
  submitProductInfoEdit,
  changeReducerState,
  fetchManufacturer,
  fetchVendor,
  fetchProductType,
}) => {

  // states declarations
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [salesProductInfoName, setProductInfoName] = useState('');
  const [sortOrder, setSortOrder] = useState("");
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [deleteProductInfoId, setDeleteProductInfoId] = useState('');
  const [show, setShow] = useState(false);
  const [ids, setIds] = useState("");
  const [state, setState] = useState({

    "manufacturerId": "",
    "vendorId": "",
    "productTypeId": "",
    "width": "",
    "length": "",
    "volume": "",
    "productStyle": "",
    "modelNumber": "",
    "collections": "",
  }
  )
  // use effect function called for authentication
  useEffect(() => {
    if (isAuthenticated) {
      fetchProductInfo(auth[0].token);
    }
  }, [auth, isAuthenticated]);


  useEffect(() => {
    if (isAuthenticated) {
      fetchManufacturer(auth[0].token);
    }
  }, [auth, isAuthenticated]);
  // use effect function called for authentication
  useEffect(() => {
    if (isAuthenticated) {
      fetchVendor(auth[0].token);
    }
  }, [auth, isAuthenticated]);
  useEffect(() => {
    if (isAuthenticated) {
      fetchProductType(auth[0].token);
    }
  }, [auth, isAuthenticated]);
  // use effect function called after api success
  useEffect(() => {
    if (isCreated === true) {
      toast.success("ProductInfo Created Successfully.");
      fetchProductInfo(auth[0].token);
      changeReducerState();
    }
    if (isDeleted === true) {
      toast.success("ProductInfo Deleted Successfully.");
      fetchProductInfo(auth[0].token);
      changeReducerState();
    }
    if (isEdited === true) {
      toast.success("ProductInfo Data Updated Successfully.");
      fetchProductInfo(auth[0].token);
      changeReducerState();
    }
  }, [isCreated, isDeleted, isEdited]);


  const handleChange = (e) => {
    const { id, value } = e.target;
    setState({ ...state, [id]: value })

  }

  // function to open create modal
  const showCreateModal = () => {
    setCreateModalOpen(true);
  };

  // function to close create modal
  const hideCreateModal = () => {
    setCreateModalOpen(false);
    setShow(false)
    setIds("");
    setState({
      "manufacturerId": "",
      "vendorId": "",
      "productTypeId": "",
      "width": "",
      "length": "",
      "volume": "",
      "productStyle": "",
      "modelNumber": "",
      "collections": ""
    })
  };

  // function called for input value change of create modal
  const handleSalesStageNameChange = (e) => {
    setProductInfoName(e.target.value);
  }
  const handleSortOrderChange = (e) => {
    setSortOrder(e.target.value);
  }

  // function called for create sales stage create api
  const handleCreateModalSubmit = (e) => {
    e.preventDefault();
    if (state.manufacturerId === '') {
      toast.error("Manufacturer cannot be empty.");
    } else {
      submitProductInfoCreate({
        "data": {
          "ManufacturerId": parseInt(state.manufacturerId),
          "VendorId": parseInt(state.vendorId),
          "ProductTypeId": parseInt(state.productTypeId),
          "Width": parseFloat(state.width),
          "Length": parseFloat(state.length),
          "Volume": parseFloat(state.volume),
          "ProductStyle": state.productStyle,
          "ModelNumber": state.modelNumber,
          "Collections": state.collections,
          "CreatedBy": auth[0].userId,
        },
        "token": auth[0].token
      });
      hideCreateModal();
    }
  }

  // function to open confirm delete modal
  const showConfirmDeleteModal = (id) => {
    setDeleteProductInfoId(id);
    setConfirmDeleteModal(true);
  };

  // function to close confirm delete modal
  const hideConfirmDeleteModal = () => {
    setDeleteProductInfoId('');
    setConfirmDeleteModal(false);
  };

  // function called for delete sales stage delete api
  const handleConfirmDeleteSubmit = () => {
    submitProductInfoDelete({
      "ProductInfoId": deleteProductInfoId,
      "token": auth[0].token
    });
    hideConfirmDeleteModal();
  }

  // function called on edit icon click
  const handleEditClick = (data) => {
    setState(data);
    setIds(data.productInfoId);
    setShow(true)
  }

  // function called to save edited data
  const handleEditSaveClick = (data) => {
    if (state.manufacturerId === '') {
      toast.error("Manufacturer cannot be empty.");
    } else {
      submitProductInfoEdit({
        "data": {
          "ProductInfoId": ids,
          "ManufacturerId": parseInt(state.manufacturerId),
          "VendorId": parseInt(state.vendorId),
          "ProductTypeId": parseInt(state.productTypeId),
          "Width": parseFloat(state.width),
          "Length": parseFloat(state.length),
          "Volume": parseFloat(state.volume),
          "ProductStyle": state.productStyle,
          "ModelNumber": state.modelNumber,
          "Collections": state.collections,
        },
        "token": auth[0].token
      });
      hideCreateModal();
    }
  }

  if (!isAuthenticated) return <Navigate to="/login" />;

  return (
    <MainWrapper>
      <Loader loading={isLoading}>
        <div className="container">
          <ToastContainer />
          <div className="sub-header mt-5 mb-3">
            <h2>ProductInfo</h2>
            <Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back to Value List</Link>
            <Create
              variant="primary"
              title={`ProductInfo`}
              createModalOpen={createModalOpen}
              showCreateModal={showCreateModal}
              hideCreateModal={hideCreateModal}
              salesStageName={salesProductInfoName}
              handleSalesStageNameChange={handleSalesStageNameChange}
              sortOrder={sortOrder}
              handleSortOrderChange={handleSortOrderChange}
              handleCreateModalSubmit={handleCreateModalSubmit}
              handleChange={handleChange}
              state={state}
              Manufacturer={Manufacturer.valueList}
              vendor={vendor.valueList}
              ProductType={ProductType.valueList}
            />
          </div>
          <Table responsive bordered>
            <thead>
              <tr>
                <th>ProductStyle</th>
                <th className="text-center">ModelNumber</th>
                <th width="50" className="actions">
                  <div className="d-flex">
                    <span>Edit</span>
                    <span>Delete</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {valueList && valueList.length > 0 ? (
                valueList.map((item, index) => (

                  <tr key={index}>
                    <td>
                      {item.productStyle}
                    </td>
                    <td width="150">
                      {item.modelNumber}
                    </td>
                    <td className="actions">
                      <div className="btn-group">
                        <Icon role="button" className="mt-2 w-54 d-flex justify-content-center" size={24} icon={ic_mode_edit} onClick={() => handleEditClick(item)} />
                        <ConfirmDelete variant="primary" title={`ProductInfo`} showConfirmDeleteModal={() => showConfirmDeleteModal(item.productInfoId)} hideConfirmDeleteModal={hideConfirmDeleteModal} handleConfirmDeleteSubmit={handleConfirmDeleteSubmit} confirmDeleteModal={confirmDeleteModal} />
                      </div>
                    </td>
                  </tr>

                ))
              ) : (
                <tr>
                  <td colSpan={4}>
                    No Data Found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Loader>
      <Edit
        state={state}
        handleChange={handleChange}
        handleEditSaveClick={handleEditSaveClick}
        show={show}
        hideCreateModal={hideCreateModal}
        title={`ProductInfo`}
        Manufacturer={Manufacturer.valueList}
        vendor={vendor.valueList}
        ProductType={ProductType.valueList}
      />
    </MainWrapper>
  )
}

const mapStateToProps = ({ auth, ProductInfo, ProductType, Manufacturer, valueList }) => {
  return {
    auth,
    ProductInfo,
    Manufacturer,
    vendor: valueList,
    ProductType
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchManufacturer: (token) => dispatch({ type: MANUFACTURER_REQUEST, token }),
    fetchProductInfo: (token) => dispatch({ type: PRODUCT_INFO_REQUEST, token }),
    submitProductInfoCreate: (data) => dispatch({ type: PRODUCT_INFO_CREATE, payload: data }),
    submitProductInfoDelete: (data) => dispatch({ type: PRODUCT_INFO_DELETE, payload: data }),
    submitProductInfoEdit: (data) => dispatch({ type: PRODUCT_INFO_EDIT, payload: data }),
    changeReducerState: () => dispatch({ type: PRODUCT_INFO_STATE_CHANGE }),
    fetchVendor: (token) => dispatch({ type: VENDOR_REQUEST, token }),
    fetchProductType: (token) => dispatch({ type: PRODUCT_TYPE_REQUEST, token }),

  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProductInfo);